import api from './api';

export const getRequestTypeOpts = () => {
  return api().get(`/request-type/get-options`);
};

export const getListRequestWarranty = (params = {}) => {
  return api().get('/request-warranty-repair', { params });
};

export const moveStepProcess = (requestId, processStepId, step_current_id, request_type_id, receiver_internal_user, note_internal, store_internal_id) =>
  api().put(`/request-warranty-repair/move-step/request/${requestId}/processstep/${processStepId}`, {
    step_current_id,
    request_type_id,
    receiver_internal_user,
    note_internal,
    store_internal_id
  });
export const getOptsCoordinatorCheckerUser = (params = {}) => {
  return api().get(`/request-warranty-repair/get-coordinator-checker-user`, { params });
};

export const updateUserWarranty = (params = {}) => {
  return api().put(`/request-warranty-repair/update-user-warranty`, params);
};

export const deleteListWarranty = (list_id = []) => {
  return api().delete('/request-warranty-repair', { data: { list_id } });
};

export const getDetailRequestDashboard = (id) => {
  return api().get(`/request-warranty-repair/dashboard/${id}`);
};

export const moveWarrantyTransfer = (requestId) =>
  api().put(`/request-warranty-repair/move-warranty-tranfer/request/${requestId}`);
